import {
  EvaluationContext,
  Hook,
  JsonValue,
  Logger,
  OpenFeatureEventEmitter,
  Provider,
  ResolutionDetails
} from '@openfeature/web-sdk';
import {BaseService} from '@twpub/core/services/base.service';
import {Injectable, Injector} from '@angular/core';
import {firstValueFrom, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeatureProvider extends BaseService implements Provider {
  readonly metadata = {
    name: 'Feature Provider'
  } as const;

  readonly runsOn = 'client';
  events = new OpenFeatureEventEmitter();
  hooks?: Hook[] | undefined;
  private featureFlags: Record<string, any> = {};
  private initialized = false;

  constructor(private injector: Injector) {
    super(injector)
    this.loadFeatureFlags();
  }

  private loadFeatureFlags(): Observable<any> {
    return this.http.get(this.url('/feature-flags'));
  }

  onContextChange?(oldContext: EvaluationContext, newContext: EvaluationContext): void | Promise<void> {
    throw new Error('Method not implemented.');
  }

  public resolveBooleanEvaluation(flagKey: string, defaultValue: boolean, context: EvaluationContext, logger: Logger): ResolutionDetails<boolean> {
    const value = this.featureFlags[flagKey];
    return {
      value: typeof value === 'boolean' ? value : defaultValue,
      reason: 'default'
    };
  }

  resolveStringEvaluation(flagKey: string, defaultValue: string, context: EvaluationContext, logger: Logger): ResolutionDetails<string> {
    const value = this.featureFlags[flagKey];
    return {
      value: typeof value === 'string' ? value : defaultValue,
      reason: 'default'
    };
  }

  resolveNumberEvaluation(flagKey: string, defaultValue: number, context: EvaluationContext, logger: Logger): ResolutionDetails<number> {
    throw new Error('Method not implemented.');
  }

  resolveObjectEvaluation<T extends JsonValue>(flagKey: string, defaultValue: T, context: EvaluationContext, logger: Logger): ResolutionDetails<T> {
    const value = this.featureFlags[flagKey];
    return {
      value: typeof value === 'object' ? value : defaultValue,
      reason: 'default'
    };
  }

  async initialize?(context?: EvaluationContext | undefined): Promise<void> {
    try {
      this.featureFlags = await firstValueFrom(this.loadFeatureFlags());
      this.initialized = true;
      this.logger.debug('Feature flags loaded successfully:', this.featureFlags);
    } catch (error) {
      this.logger.error('Error initializing feature flags:', error);
      // Set empty object so service continues to work with defaults
      this.featureFlags = {};
      this.initialized = true; // Mark as initialized even on error
    }
  }
}
